import { Link } from 'react-router-dom';
import { assetUrl } from '../api/client';
import { formatDate, truncate } from '../lib/format';

export default function StoryCard({ story, featured = false }) {
  const img = assetUrl(story.featured_image_path) || '/img/story-a.jpg';
  const to = `/stories/${story.slug || story.id}`;
  return (
    <article className={`card card-hover group overflow-hidden ${featured ? 'sm:col-span-2 sm:flex' : ''}`}>
      <Link to={to} className={featured ? 'sm:w-1/2' : 'block'}>
        <div className={`relative overflow-hidden bg-maroon-50 ${featured ? 'h-56 sm:h-full' : 'aspect-[16/10]'}`}>
          <img
            src={img}
            alt={story.title}
            loading="lazy"
            className="h-full w-full rounded-t-2xl object-cover transition-transform duration-500 group-hover:scale-105"
          />
          {story.category && (
            <span className="pill-gold absolute left-3 top-3">{story.category.name}</span>
          )}
          {story.is_featured && (
            <span className="pill absolute right-3 top-3 bg-gold-400 text-maroon-900">★ Featured</span>
          )}
        </div>
      </Link>
      <div className={`flex flex-col p-5 ${featured ? 'sm:w-1/2 sm:justify-center' : ''}`}>
        <div className="mb-2 flex items-center gap-2 text-xs text-ink-muted">
          {story.published_at && <span>{formatDate(story.published_at)}</span>}
        </div>
        <h3 className="mb-2 font-display text-lg font-bold leading-snug text-ink transition-colors group-hover:text-maroon-700">
          <Link to={to}>{story.title}</Link>
        </h3>
        <p className="text-sm text-ink-muted line-clamp-2">
          {truncate(story.excerpt || story.body, featured ? 180 : 110)}
        </p>
        <div className="mt-4 flex items-center justify-between text-xs text-ink-muted">
          {story.author && <span>By {story.author.name}</span>}
          <Link to={to} className="link-caps">
            Read more <span aria-hidden="true">&rsaquo;</span>
          </Link>
        </div>
      </div>
    </article>
  );
}
